




































































































/** @format */
import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import AddEditModal from './components/add-edit-model.vue';
import {
  businessList,
  businessDetail,
  deleteBusiness,
  resetPwdBusiness,
  merchantExport
} from '@/api/discount-management/index';
import { businessTypeMap } from '@/types/discount-management/dictionaries';
import Utils from '@root/utils/common';
import { BUSINESS_LIST_DETAIL, BUSINESS_LIST_PARKING_POOL } from '../router-names';
import OrganizationSearch from '@/components/organization-search/index.vue';
@Component({
  name: 'BusinessList',
  components: { ParkingLotSearch, AddEditModal, OrganizationSearch }
})
export default class BusinessList extends Mixins(TableMixin, TableWidthMixin) {
  private filterParam: any = {
    parkIds: [], //选中的车场
    name: '',
    moblie: '',
    type: '',
    orgdepId: ''
  };
  // options = Utils.toLabelVal(businessTypeMap)
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_merc_type);
  businessType = ''; //商户类型
  // orgdepId = ''
  private tableLoading: boolean = false;
  editModel: boolean = false; //弹出框是否显示
  tableData: any[] = [];
  isEdit: boolean = false;
  addEditModalData: any = null;
  isOrgRoot = true;

  //默认选中机构根节点
  selectDefaultRoot(val: any) {
    this.filterParam.orgdepId = val;
  }
  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '商户名称',
        dataIndex: 'name',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '商户类型',
        dataIndex: 'type',
        width: 140
      },
      {
        title: '所属停车场',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '联系人',
        dataIndex: 'linkman',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '手机号',
        dataIndex: 'mobile',
        width: 180
      },
      {
        title: '登录账户',
        dataIndex: 'loginId',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      // {
      //   title: '启用拍照功能',
      //   dataIndex: 'takePhotosStatus',
      //   width: 180,
      // },
      {
        title: '更新时间',
        dataIndex: 'updateTime',
        width: 200
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 300,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  //table初始化
  current = 1;
  pageSize = 10;
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { parkIds, ...rest } = this.filterParam;
      const { status, code, msg, data } = await businessList({
        ...rest,
        parkIds: this.filterParam.parkIds.join(','),
        orgdepId: this.filterParam.orgdepId,
        page: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear() {
    this.filterParam = {
      parkIds: [],
      name: '',
      type: '',
      mobile: '',
      orgdepId: ''
    };
    // @ts-ignore hack
    this.$refs.orgTree.setRootId();
    this.$nextTick(() => {
      this.searchTable();
    });
  }

  showFlag = false;
  //新增 修改
  async editItem(val?: any) {
    if (val) {
      this.isEdit = true;
      try {
        const { status, code, msg, data } = await businessDetail({ id: val.id });
        this.addEditModalData = { ...data, merchantAccountId: val.merchantAccountId };
        if (data.type === '04') {
          this.showFlag = true;
        } else {
          this.showFlag = false;
        }
        // if (data.applyPark === '00') {
        //   this.addEditModalData.parkIds = 'all'
        // }
        if (data && data.parkIds) {
          this.addEditModalData.parkIds = data.parkIds.split(',');
        }
      } catch (error) {
        console.log(error);
        return this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      }
    } else {
      this.isEdit = false;
    }
    this.editModel = true;
  }
  //重置密码
  resetPassword(val: any) {
    const that = this;
    this.$confirm({
      title: '重置密码',
      content: '新密码为该账号关联手机号的后6位数，确认要重置吗？',
      async onOk() {
        try {
          const { status, msg, code, data } = await resetPwdBusiness({
            id: val.id
          });
          if (status === '9999') {
            that.$message.success('重置密码成功');
            that.fetchTableData();
          } else {
            that.$message.error(msg ? msg : '密码重置失败');
          }
        } catch (e) {
          console.log('报错了');
          that.$message.error((e && e.msg) || '重置密码失败');
        }
      },
      onCancel() {}
    });
    //this.$message.success('密码已重置,新密码为该账号关联手机号的后6位数')
  }
  //删除
  deleteItem(val: any) {
    const that = this;
    this.$confirm({
      title: '提示',
      content: `你确定要删除商户${val.name}么？删除后商户将无法使用商家端。`,
      async onOk() {
        try {
          console.log(val.id);
          const { status, msg, code, data } = await deleteBusiness({
            id: val.id
          });
          if (status === '9999') {
            that.$message.success('删除成功');
            that.fetchTableData();
          } else {
            that.$message.error(msg ? msg : '删除失败');
          }
        } catch (e) {
          that.$message.error((e && e.msg) || '删除失败');
        }
      },
      onCancel() {}
    });
  }
  checkoutShowFlag(val: boolean) {
    console.log(val);
    this.showFlag = val;
  }
  //弹窗取消
  handleModalCancel() {
    this.editModel = false;
  }
  //弹窗保存
  handleModalCreate() {
    this.editModel = false;
    this.fetchTableData(true);
  }
  created() {
    this.fetchTableData();
  }

  toDetail(row: { id: any }) {
    this.$router.push({
      name: BUSINESS_LIST_DETAIL,
      params: {
        row: row,
        id: row.id
      }
    } as any);
  }

  // 车位池
  toParkingPool(row) {
    this.$router.push({
      name: BUSINESS_LIST_PARKING_POOL,
      query: {
        merchantId: row.id,
        name: row.name,
        mobile: row.mobile
      }
    });
  }

  // changeParking(value, label, extra) {
  //   if (
  //     extra &&
  //     extra.allCheckedNodes &&
  //     extra.allCheckedNodes[0] &&
  //     extra.allCheckedNodes[0].node &&
  //     extra.allCheckedNodes[0].node.componentOptions &&
  //     extra.allCheckedNodes.length === 1
  //   ) {
  //     if (
  //       extra.allCheckedNodes[0].node.componentOptions.propsData.dataRef &&
  //       extra.allCheckedNodes[0].node.componentOptions.propsData.dataRef.children
  //     ) {
  //       this.orgdepId = extra.allCheckedNodes[0].node.componentOptions.propsData.value
  //     } else {
  //       this.orgdepId = ''
  //     }
  //   } else {
  //     this.orgdepId = ''
  //   }
  // }
  downFlag: boolean = false;
  //导出
  private async downLoad() {
    try {
      if (this.downFlag) return;
      this.downFlag = true;
      const { ...rest } = this.filterParam;
      await merchantExport(
        {
          ...rest,
          parkIds: this.filterParam.parkIds.join(','),
          orgdepId: this.filterParam.orgdepId
        },
        '商家管理'
      );
    } catch (e) {
      console.log(e);
    } finally {
      this.downFlag = false;
    }
  }
}
